<!-- start features -->
<section class="section" id="contact">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="text-center mb-5">
                    <h2 class="mb-3 fw-bold lh-base">Articles</h2>
                    <p class="text-muted">Dive into our collection of bird watching articles, where every story takes you on a feather-filled journey into the heart of nature, unveiling the secret lives of our winged wonders and offering tips, tricks, and tales that will have you soaring with knowledge and excitement!</p>
                </div>
            </div><!-- end col -->
        </div><!-- end row -->

        <div class="row">
            <div class="col-lg-3" *ngFor="let data of featuresData">
                <div class="card shadow-none">
                    <div class="card-body">
                        <img src="{{data.image}}" alt="" class="avatar-sm">
                        <h5 class="mt-4">{{data.title}}</h5>
                        <p class="text-muted fs-14">{{data.content}}</p>
                        <a href="javascript:void(0);" class="link-success fs-14">Read More <i class="ri-arrow-right-line align-bottom"></i></a>
                    </div>
                </div>
            </div><!--end col-->
        </div><!--end row-->
    </div><!-- end container -->
</section><!-- end features -->
